import React from "react";
const ChildDashboard = React.lazy(() =>
  import(/* webpackChunkName: "childDashboard" */ "./childdetail/ChildDashboard/ChildDashboard")
);
const ChildProfile = React.lazy(() =>
  import(/* webpackChunkName: "childProfile" */ "./childdetail/ChildProfile/ChildProfile")
);
//const Enrollment = React.lazy(() =>
//  import(/* webpackChunkName: "enrollment" */ "./childdetail/Enrollment/Enrollment")
//);
const ChildRegister = React.lazy(() =>
  import(/* webpackChunkName: "childRegister2" */ "./childdetail/ChildRegister/ChildRegister")
);
const Billing = React.lazy(() =>
  import(/* webpackChunkName: "billing" */ "./childdetail/Billing/Billing")
);
const DaycareDetails = React.lazy(() =>
  import(/* webpackChunkName: "DaycareDetails" */ "./Daycare/DaycareDetails")
);
const ViewSections = React.lazy(() =>
  import(/* webpackChunkName: "ViewSections" */ "./Daycare/ViewSections")
);
const ViewGroups = React.lazy(() =>
  import(/* webpackChunkName: "ViewGroups" */ "./Daycare/ViewGroups")
);
const Presence = React.lazy(() =>
  import(/* webpackChunkName: "Presence" */ "./childdetail/Presence/Presence")
);
//const Prospects = React.lazy(() =>
//  import(/* webpackChunkName: "Prospects" */ "./childdetail/Prospects/Propects")
//);

//const Reports = React.lazy(() =>
//  import(/* webpackChunkName: "Reports" */ "./Daycare/FinancialReporting/Reports")
//); 
const PnL = React.lazy(() =>
  import(/* webpackChunkName: "PnL" */ "./reports/PnL/Finance")
);

const ChildReport = React.lazy(() =>
  import(/* webpackChunkName: "ChildReport" */ "../screens/reporting/childReporting")
);

const DaycareReport = React.lazy(() =>
  import(/* webpackChunkName: "DaycareReport" */ "../screens/reporting/daycareReporting")
);

const ProfessionalReport = React.lazy(() =>
  import(/* webpackChunkName: "ProfessionalReport" */ "../screens/reporting/staffReporting")
);

const ActivityReport = React.lazy(() =>
  import(/* webpackChunkName: "ActivityReport" */ "../screens/reporting/activityReporting")
);

const FinanceReport = React.lazy(() =>
  import(/* webpackChunkName: "FinanceReport" */ "./reports/PnL/Finance")
);

const Child360 = React.lazy(() =>
  import(/* webpackChunkName: "Child360" */ "../screens/reporting/child360")
);

const ChildResults = React.lazy(() =>
  import(/* webpackChunkName: "ChildResults" */ "./childdetail/childResults/ChildResults")
); 

const ChildResultsTemplate = React.lazy(() =>
  import(/* webpackChunkName: "ChildResultsTemplate" */ "./childdetail/childResults/ChildResultsTemplate")
);


// RM: removal of staffmanagement folder from src
//const staffManagement = React.lazy(() =>
//  import(/* webpackChunkName: "staffManagement" */ "../staffmanagement/staffprofileDM")
//);
const PayRoll = React.lazy(() =>
  import(/* webpackChunkName: "payroll" */ "./StaffManagement/PayRoll")
);
const MyDay = React.lazy(() => import(/* webpackChunkName: "MyDay" */ "./Daycare/MyDay/MyDay"));
const profile = React.lazy(() => import(/* webpackChunkName: "profile" */ "./profile"));
const leaveCalendar = React.lazy(() =>
  import(/* webpackChunkName: "leaveCalendar" */ "./StaffManagement/LeaveCalender")
);
const staffProfile = React.lazy(() =>
  import(/* webpackChunkName: "leaveCalendar" */ "./StaffManagement/Profile/Profile")
);
const ViewSessions = React.lazy(() =>
  import(/* webpackChunkName: "SessionManagement" */ "./Daycare/ViewSessions")
);
const ViewTerms = React.lazy(() =>
  import(/* webpackChunkName: "TermsManagement" */ "./Daycare/ViewTerms")
);
const UserManagement = React.lazy(() =>
  import(/* webpackChunkName: "UserManagement" */ "./Access/UserManagement/UserManagement")
);

const CreateActivity = React.lazy(() =>
  import(/* webpackChunkName: "CreateActivity" */ "./Activities/CreateActivity/CreateActivity")
);
const ManageActivity = React.lazy(() =>
  import(/* webpackChunkName: "ManageActivity" */ "./Activities/ManageActivity/ManageActivity")
);

const Milestones = React.lazy(() =>
  import(/* webpackChunkName: "SessionManagement" */ "./Activities/Milestones/Milestones")
);
const Skill = React.lazy(() =>
  import(/* webpackChunkName: "SessionManagement" */ "./Activities/Skill/Skills")
);
const Category = React.lazy(() =>
  import(/* webpackChunkName: "SessionManagement" */ "./Activities/Category/Category")
);

const ParentAccess = React.lazy(() =>
  import(/* webpackChunkName: "LiveDashboard" */ "./Access/parentAccess/ParentAccess")
);

//const LiveDashboard = React.lazy(() =>
//  import(/* webpackChunkName: "LiveDashboard" */ "./Live/LiveDashboard")
//);

const CreateMenu = React.lazy(() =>
  import(/* webpackChunkName: "CreateMenu" */ "./MealManagement/CreateMenu")
);

const MealPlan = React.lazy(() =>
  import(/* webpackChunkName: "MealPlan" */ "./MealManagement/MealPlan/MealPlan")
);

const EnrollmentNew = React.lazy(() =>
  import(/* webpackChunkName: "EnrollmentNew" */ "./Leads/Enrollment/Enrollment")
);

const ProspectsNew = React.lazy(() =>
  import(/* webpackChunkName: "ProspectsNew" */ "./Leads/Prospects/Propects")
);


//const WebEnquires = React.lazy(() =>
//  import(/* webpackChunkName: "ProspectsNew" */ "./Leads/Prospects/Propects")
//);

const SurveyParents = React.lazy(() =>
  import(/* webpackChunkName: "ProspectsNew" */ "./Leads/Survey/Survey")
);

const WebsiteMgt = React.lazy(() =>
  import(/* webpackChunkName: "ProspectsNew" */ "./Leads/Website/Website")
);

//const WebVisitors = React.lazy(() =>
//  import(/* webpackChunkName: "ProspectsNew" */ "./Leads/Prospects/Propects")
//);


//const Finance = React.lazy(() => import("./Daycare/Finance"));
export const subModuleData = {
  childManagement: [
    {
      name: "childDashboard",
      url: "/childManagement/childDashboard",
      component: "ChildDashboard",
    },
    {
      name: "childProfile",
      url: "/childManagement/childProfile",
      component: "ChildProfile",
    },
   /* {
      name: "enrollment",
      url: "/childManagement/enrollment",
      component: "Enrollment",
    },*/
    {
      name: "registerChild",
      url: "/childManagement/childRegister",
      component: "ChildRegister",
    },
    {
      name: "billing",
      url: "/childManagement/billing",
      component: "Billing",
    },
    {
      name: "presence",
      url: "/childManagement/presence",
      component: "Presence",
    },
    {
      name: "child360",
      url: "/childManagement/child360",
      component: "Child360",
    },
    {
      name: "childresults",
      url: "/childManagement/results",
      component: "ChildResults",
    },
    {
      name: "childresultstemplate",
      url: "/childManagement/resultstemplate",
      component: "ChildResultsTemplate",
    },
   /* {
      name: "prospects",
      url: "/childManagement/prospects",
      component: "Prospects",
    },*/
  ],
  daycare: [
    {
      name: "daycareDetails",
      url: "/myDaycareNew/details",
      component: "DaycareDetails",
    },
    {
      name: "sections",
      url: "/myDaycareNew/sections",
      component: "ViewSections",
    },
    {
      name: "groups",
      url: "/myDaycareNew/groups",
      component: "ViewGroups",
    },
  //  {
  //    name: "reports",
  //    url: "/myDaycareNew/reports",
  //    component: "Reports",
  //  },
    {
      name: "myDay",
      url: "/myDaycareNew/myday",
      component: "MyDay",
    },
    {
      name: "sessions",
      url: "/myDaycareNew/viewSessions",
      component: "ViewSessions",
    },
    {
      name: "terms",
      url: "/myDaycareNew/viewTerms",
      component: "ViewTerms",
    },
  //  {
  //    name: "finance",
  //    url: "/myDaycareNew/finance",
  //    component: "Finance",
   // },
   //original code
   // {
   //   name: "userManagement",
   //   url: "/myDaycareNew/userManagement",
   //   component: "UserManagement",
  //  },
  ],
  staffManagement: [
    { name: "profiles", url: "/staffmanagement/profile", component: "staffProfile" },
    { name: "payroll", url: "/staffmanagement/payroll", component: "payRoll" },
    { name: "leaveCalendar", url: "/staffmanagement/leavecalendar", component: "leaveCalendar" },
  ],
 
  reports: [
    {
      name: "pnl",
      url: "/reports/pnl",
      component: "PnL",
    },
    // {
    //   name: "childReport",
    //   url: "/reports/childReport",
    //   component: "ChildReport",
    // },
    {
      name: "daycareReport",
      url: "/reports/daycareReport",
      component: "DaycareReport",
    },
    {
      name: "professionalReport",
      url: "/reports/professionalReport",
      component: "ProfessionalReport",
    },
    {
      name: "activityReport",
      url: "/reports/activityReport",
      component: "ActivityReport",
    },
    {
      name: "financeReport",
      url: "/reports/financeReport",
      component: "FinanceReport",
    },
  ],
  activities: [
     {
      name: "manageActivities",
      url: "/activity/manage",
      component: "ManageActivity",
    },
    {
      name: "createActivities",
      url: "/activity/create",
      component: "CreateActivity",
    },
   
    {
      name: "milestones",
      url: "/activity/milestones",
      component: "Milestones",
    },
    {
      name: "category",
      url: "/activity/category",
      component: "Category",
    },
    {
      name: "skills",
      url: "/activity/skills",
      component: "Skills",
    },
   
  ],
  access: [
    {
      name: "userManagement",
      url: "/access/userManagement",
      component: "UserManagement",
    },
    {
      name: "parentAccess",
      url: "/access/parentAccess",
      component: "ParentAccess",
    },
  ],

  leads: [
    {
      name: "enrollment",
      url: "/leads/enrollment",
      component: "EnrollmentNew",
    },
   
    {
      name: "prospects",
      url: "/leads/prospects",
      component: "ProspectsNew",
    },
    {
      name: "website",
      url: "/leads/website",
      component: "WebsiteMgt",
    },

      {
      name: "surveys",
      url: "/leads/survey",
      component: "SurveyParents",
    },

 /*   {
      name: "webenqueries",
      url: "/leads/prospects",
      component: "WebEnqueries",
    },
*/
    
/*
    {
      name: "webvisitors",
      url: "/leads/prospects",
      component: "WebVisitors",
    }, */
  ],

   mealManagement: [
     {
      name: "mealPlan",
      url: "/mealmanagement/mealplan",
      component: "MealPlan",
    },
    {
      name: "createMenu",
      url: "/mealmanagement/createmenu",
      component: "CreateMenu",
    },
  
  ],
  /*
  live: [
    {
      name: "liveStream",
      url: "/live",
      component: "LiveDashboard",
    },
  ],

  mealManagement: [
    {
      name: "createMenu",
      url: "/mealmanagement/createmenu",
      component: "CreateMenu",
    },
   
  ],*/

};

export const components = {
  ChildDashboard: ChildDashboard,
  ChildProfile: ChildProfile,
  //Enrollment: Enrollment,// moved enrollment under leads
  ChildRegister: ChildRegister,
  Billing: Billing,
  Presence: Presence,
  //Prospects: Prospects, // moved prospects under leads
  DaycareDetails: DaycareDetails,
  ViewSections: ViewSections,
  ViewGroups: ViewGroups,
  //Reports: Reports,
  MyDay: MyDay,
  ViewSessions: ViewSessions,
  ViewTerms: ViewTerms,
  //Finance: Finance,
  // RM removal of staffnamanegement from src folder
  //staffManagement: staffManagement,
  
  PnL: PnL,
  // ChildReport: ChildReport,
  DaycareReport: DaycareReport,
  ProfessionalReport: ProfessionalReport,
  ActivityReport: ActivityReport,
  FinanceReport: FinanceReport,
  Child360: Child360,
  ChildResults: ChildResults,
  ChildResultsTemplate: ChildResultsTemplate,
  payRoll: PayRoll,
  leaveCalendar: leaveCalendar,
  staffProfile: staffProfile,
  UserManagement: UserManagement,

  CreateActivity: CreateActivity,
  ManageActivity: ManageActivity,
  Milestones: Milestones,
  Category: Category,
  Skills: Skill,
  ParentAccess: ParentAccess,
  EnrollmentNew: EnrollmentNew,
  ProspectsNew: ProspectsNew,
  //WebEnquires: WebEnquires,
  SurveyParents: SurveyParents,
  WebsiteMgt: WebsiteMgt,
  //WebVisitors: WebVisitors,
  //LiveDashboard: LiveDashboard,
  CreateMenu: CreateMenu,
  MealPlan: MealPlan,
 

};
